import React from 'react';
import s from './RadioEl.style';


const RadioBtnRow = (props) => {
  const { title, subTitle, ...inputProps } = props;
  
  return <s.RadioBtnRow className="radio-row">
    <input type="radio" hidden  {...inputProps} />
    <label htmlFor={inputProps.id}>
      <div className="info">
        <p>{title}</p>
        <p className="sub-title">{subTitle}</p>
      </div>
      <s.Indicator className="indicator" />
    </label>
  </s.RadioBtnRow>;
};

export default RadioBtnRow;
